import { alpha } from '@mui/material/styles';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';

// ----------------------------------------------------------------------

export function overrides(theme) {
    return {
        MuiCssBaseline: {
            styleOverrides: {
                '*': {
                    boxSizing: 'border-box',
                    margin: '0',
                    padding: '0',

                    scrollbarWidth: 'thin', // For Firefox
                    scrollbarColor: `${theme.palette.common.pastelBlue} ${theme.palette.background.default}`, // Thumb and track color for Firefox
                    '&::-webkit-scrollbar': {
                        width: '8px', // Width of the scrollbar for WebKit browsers
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: theme.palette.common.pastelBlue, // Thumb color for WebKit
                        borderRadius: '10px', // Rounded corners for WebKit
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: theme.palette.background.default, // Track color for WebKit
                    },
                },
                html: {
                    width: '100%',
                    height: '100%',
                    WebkitOverflowScrolling: 'touch',
                },
                body: {
                    width: '100%',
                    height: '100%',
                },
                '#root': {
                    width: '100%',
                    minHeight: '100vh',
                    height: '100%',
                    overflow: 'auto'
                },
                strong: {
                    fontWeight: theme.typography.fontWeightSemiBold,
                },
                b: {
                    fontWeight: theme.typography.fontWeightSemiBold,
                },
                input: {
                    '&[type=number]': {
                        MozAppearance: 'textfield',
                        '&::-webkit-outer-spin-button': {
                            margin: 0,
                            WebkitAppearance: 'none',
                        },
                        '&::-webkit-inner-spin-button': {
                            margin: 0,
                            WebkitAppearance: 'none',
                        },
                    },
                },
                img: {
                    maxWidth: '100%',
                    display: 'inline-block',
                    verticalAlign: 'bottom',
                },
            },
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    backgroundColor: alpha(theme.palette.grey[900], 0.8),
                },
                invisible: {
                    background: 'transparent',
                },
            },
        },
        MuiButton: {
            // defaultProps: {
            //     // The props to change the default for.
            //     disableRipple: true, // No more ripple, on the whole application 💣!
            // },
            styleOverrides: {
                root: {
                    textTransform: 'inherit',
                    borderRadius: theme.typography.borderRadius.veryLarge,
                    padding: `${theme.typography.generic.xSmall} ${theme.typography.generic.xLarge}`,

                    variants: [
                        {
                            props: (props) => {
                                return props.variant === 'contained' && props.color === 'primary';
                            },

                            style: {},
                        },

                        {
                            props: (props) => {
                                return props.variant === 'outlined' && props.color === 'primary';
                            },

                            style: {},
                        },

                        {
                            props: (props) => {
                                return props.size === 'medium';
                            },
                            style: {
                                fontSize: theme.typography.customFontSize.medium,
                                lineHeight: theme.typography.customFontSize.medium,

                                '& .MuiButton-icon.MuiButton-startIcon>*:nth-of-type(1)': {
                                    fontSize: theme.typography.customFontSize.large,
                                },
                            },
                        },

                        {
                            props: (props) => {
                                return props.size === 'small';
                            },

                            style: {
                                fontSize: theme.typography.customFontSize.xSmall,
                                lineHeight: theme.typography.customFontSize.small,

                                '& .MuiButton-icon.MuiButton-startIcon>*:nth-of-type(1)': {
                                    fontSize: theme.typography.customFontSize.xxLarge,
                                },
                            },
                        },
                    ],

                    '&.Mui-disabled': {
                        color: theme.palette.gray[600],
                    },
                },

                sizeLarge: {
                    // minHeight: 48,
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    // boxShadow: theme.customShadows.card,
                    // borderRadius: Number(theme.shape.borderRadius) * 2,
                    // position: 'relative',
                    // zIndex: 0, // Fix Safari overflow: hidden with border radius

                    borderRadius: theme.typography.borderRadius.medium,
                    border: `1px solid ${theme.palette.border.neutralPrimary}`,
                    background: theme.palette.background.paper,
                },
            },
        },
        MuiCardHeader: {
            defaultProps: {
                titleTypographyProps: { variant: 'h6' },
                subheaderTypographyProps: { variant: 'body2' },
            },
            styleOverrides: {
                root: {
                    padding: theme.spacing(3, 3, 0),
                },
            },
        },
        MuiCardActions: {
            defaultProps: {},
            styleOverrides: {
                root: {
                    padding: theme.typography.generic.xLarge, //16px
                },
            },
        },
        MuiOutlinedInput: {
            // defaultProps: {
            //     color: 'secondary',
            // },
            styleOverrides: {
                root: {
                    color: theme.palette.text.secondary, //set text color

                    [`& .${outlinedInputClasses.notchedOutline}`]: {
                        borderColor: theme.palette.black[400],
                    },

                    [`&.Mui-disabled .${outlinedInputClasses.notchedOutline}`]: {
                        borderColor: theme.palette.black[300],
                    },

                    '& .MuiOutlinedInput-input': {
                        padding: '12px 16px',
                    },
                },
                // colorSecondary: {
                //     color: theme.palette.text.secondary,
                // },
            },
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0,
                // color:"secondary"
                // square:true
            },
            styleOverrides: {
                root: {
                    background: theme.palette.background.paper,
                    color: theme.palette.text.secondary,
                },
                rounded: {
                    borderRadius: theme.typography.borderRadius.medium,
                },
                outlined: {
                    border: `1px solid ${theme.palette.border.neutralPrimary}`,
                },
                // colorSecondary:{
                //     color:"red"
                // }
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    color: theme.palette.text.secondary,
                    backgroundColor: theme.palette.background.neutral,
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: theme.palette.grey[800],
                },
                arrow: {
                    color: theme.palette.grey[800],
                },
            },
        },
        MuiTypography: {
            defaultProps: {
                color: theme.palette.text.secondary, // Keep the default behavior
            },
            styleOverrides: {
                paragraph: {
                    marginBottom: theme.spacing(2),
                },
                gutterBottom: {
                    marginBottom: theme.spacing(1),
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    ...theme.typography.body2,
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    // color: theme.palette.icon.neutralTertiary,
                    // fontSize: "inherit", // Default SVG icon size
                    // lineHeight: 80 / 64,
                    // fontSize: pxToRem(theme.typography.fontSize * 1),
                    // ...responsiveFontSizes({ xs: 16, sm: 16, md: 18, lg: 24 }),

                    variants: [
                        {
                            props: (props) => {
                                return props.color === 'secondary';
                            },

                            style: {
                                color: theme.palette.icon.neutralTertiary,
                            },
                        },
                    ],
                },
                // fontSizeSmall: {
                //   fontSize: pxToRem(cFontSize * 1.28), // Equivalent to h5 size
                //   [theme.breakpoints.down("sm")]: {
                //     fontSize: pxToRem(cFontSize * 1.1), // Smaller size for small screens
                //   },
                // },
                // fontSizeLarge: {
                //   fontSize: pxToRem(cFontSize * 2.85), // Equivalent to h1 size
                //   [theme.breakpoints.down("md")]: {
                //     fontSize: pxToRem(cFontSize * 2.5), // Smaller size for medium screens
                //   },
                //   [theme.breakpoints.down("sm")]: {
                //     fontSize: pxToRem(cFontSize * 2.0), // Smaller size for small screens
                //   },
                // },
            },
        },

        MuiInputBase: {
            styleOverrides: {
                root: {},
            },
        },

        // MuiSelect: {
        //   styleOverrides: {},
        // },

        MuiAvatar: {
            styleOverrides: {
                root: {
                    fontSize: '1rem',
                    backgroundColor: '#ff8600e8',
                },
            },
        },
    };
}
